export const CampaignStatus = {
	ACTIVE: 1,
	SCHEDULED: 2,
	EXPIRED: 3,
	CLOSED: 4,
	DRAFT: 5,
	APPROVED: 6,
	PENDING: 7,
	DECLINED: 8,
	PROCESSING: 9,
	ERROR: 10
};

export const CampaignStatusNames = {
	[CampaignStatus.ACTIVE]: 'Active',
	[CampaignStatus.SCHEDULED]: 'Scheduled',
	[CampaignStatus.EXPIRED]: 'Expired',
	[CampaignStatus.CLOSED]: 'Draft',
	[CampaignStatus.DRAFT]: 'Closed',
	[CampaignStatus.APPROVED]: 'Pending',
	[CampaignStatus.PENDING]: 'Approved',
	[CampaignStatus.DECLINED]: 'Declined',
	[CampaignStatus.PROCESSING]: 'Processing',
	[CampaignStatus.ERROR]: 'Error'
};

export const CampaignTimeUnits = {
	NONE: 1,
	YEAR: 2,
	MONTH: 3,
	WEEK: 4,
	DAY: 5,
	HOUR: 6
};
export const CampaignTimeUnitLabels = {
	[CampaignTimeUnits.NONE]: 'None',
	[CampaignTimeUnits.YEAR]: 'Year',
	[CampaignTimeUnits.MONTH]: 'Month',
	[CampaignTimeUnits.WEEK]: 'Week',
	[CampaignTimeUnits.DAY]: 'Day',
	[CampaignTimeUnits.HOUR]: 'Hour'
};
